import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';

export default function EmailVerified() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [success, setSuccess] = useState('');

  const verifyEmail = async () => {
    try {
      const res = await axios.put('/api/emailverify', { token });
      setSuccess(res.data.message);
      console.log('✅ Verification response:', res.data);
    } catch (error) {
      console.error('❌ Verification failed:', error);
      setSuccess(error.response.data.message);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-layout">
        <aside className="auth-hero">
          <div>
            <p className="auth-hero__eyebrow">Email verification</p>
            <h1 className="auth-hero__title">Confirm your inbox</h1>
            <p className="auth-hero__copy">Verify your email to finish setup and unlock the app.</p>
          </div>

          <div className="auth-hero__notes">
            <span className="auth-hero__note">Secure account</span>
            <span className="auth-hero__note">Login ready</span>
            <span className="auth-hero__note">Todo sync</span>
          </div>
        </aside>

        <section className="auth-card" style={{ animation: 'slideUp 0.6s ease-out' }}>
          <h2 className="auth-card__title">Verify Email</h2>
          <p className="auth-card__copy">Tap the button below to confirm this address.</p>

          {success && <div className="auth-status is-success">{success}</div>}

          <div className="auth-actions">
            <button type="button" onClick={verifyEmail} className="auth-submit">
              Verify Email
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
